export default "__VITE_ASSET__DE0FGv6m__"